export default [
  {
    path: '/support',
    name: 'support',
    component: () => import('./index.vue'),
    meta: {
      title: 'Поддержка',
      layout: 'ui-design',
      hideMeta: true,
    },
  },
];
